import { BasicOnOff } from "@smartsuite/react-ui/lib";
import { FormFieldControl } from "../../../components/FormFieldControl/FormFieldControl";
import { useFormField } from "../../../hooks/useFormField";
import { $t } from "../../../utils/intl";
import type { FormFieldProps } from "../../types";
import { yesNoFieldText } from "./YesNoFieldControl.text";

export const YesNoFieldControl: React.FunctionComponent<FormFieldProps> = ({
  name,
  label,
  caption,
  formItem,
  readOnly,
}) => {
  const formField = useFormField<boolean>({
    name,
  });

  return (
    <FormFieldControl
      captionAsTooltip={formItem.params.help_text_as_tooltip}
      label={label}
      caption={caption}
      helpText={formItem.params.helpText}
      required={false}
      state={formField.state}
      errorMessage={formField.errorMessage}
      readOnly={readOnly}
    >
      <BasicOnOff
        size="l"
        isChecked={formField.value ?? false}
        onChange={formField.onChange}
        onText={$t(yesNoFieldText.yes)}
        offText={$t(yesNoFieldText.no)}
      />
    </FormFieldControl>
  );
};
